import { useState } from "react";
import { X } from "lucide-react";
import { changePassword, formatError } from "../lib/api";

export default function ChangePasswordModal({ onClose }) {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState("");

  const save = async () => {
    setErr("");
    if (next !== confirm) { setErr("New passwords do not match."); return; }
    if (next.length < 6) { setErr("New password must be at least 6 characters."); return; }
    setBusy(true);
    try {
      await changePassword(cur, next);
      setMsg("Password updated successfully.");
      setTimeout(onClose, 1200);
    } catch (e) {
      setErr(formatError(e.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" onMouseDown={onClose}>
      <div className="modal" style={{ width: "min(440px,100%)" }} onMouseDown={(e) => e.stopPropagation()} data-testid="password-modal">
        <div className="modal-head">
          <h3>Change Password</h3>
          <button className="icon-btn" onClick={onClose}><X /></button>
        </div>
        <div className="modal-body">
          {err && <div className="login-error">{err}</div>}
          {msg && <div className="form-success">{msg}</div>}
          <div className="field">
            <label>Current Password</label>
            <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="pwd-current" />
          </div>
          <div className="field">
            <label>New Password</label>
            <input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="pwd-new" />
          </div>
          <div className="field">
            <label>Confirm New Password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="pwd-confirm" />
          </div>
        </div>
        <div className="modal-foot">
          <button className="btn btn-ghost btn-sm" style={{ color: "var(--ink)", borderColor: "var(--line)", background: "#fff" }} onClick={onClose}>Cancel</button>
          <button className="btn btn-primary btn-sm" onClick={save} disabled={busy} data-testid="pwd-save">
            {busy ? "Saving…" : "Update Password"}
          </button>
        </div>
      </div>
    </div>
  );
}
